module.exports = __webpack_public_path__ + "img/product-preview-52.81901ea.png";